<template>
  <div
    class="d-flex align-center justify-center"
    :style="{ height }"
  >
    <v-progress-circular
      indeterminate
      :size="size"
      :width="width"
      :color="color"
    />
  </div>
</template>

<script>
export default {
  name: 'spinner',
  props: {
    height: { type: String, default: '320px' },
    size: { type: Number, default: 48 },
    width: { type: Number, default: 4 },
    color: { type: String, default: 'primary' }
  }
};
</script>
